// use when you need to indicate the source of the request
export enum SourceEnum {
  // only need one since this IS the back office SPA. Something obscure so it can't be guessed in the publicly facing site.
  BackOfficeSpa = 1996,
}
